import TextAreaHookForm from "components/TextAreaHookForm";
import { useFormContext } from "react-hook-form";

const ProducerCodeNotes = () => {
  const formMethods = useFormContext();
  const {
    register,
    watch,
    formState: { errors },
  } = formMethods;

  const notesValue = watch("notes") || "";
  const maxLength = 350;

  return (
    <div className="w-full space-y-1">
      <div className="w-full items-start gap-2">
        <label
          htmlFor="notes"
          className="flex items-stretch pb-2 text-left expandedLabel fontExpand"
        >
          Notes:
        </label>

        <div className="col-span-2">
          <TextAreaHookForm
            id="notes"
            register={register("notes", {
              maxLength: {
                value: maxLength,
                message: `Notes cannot exceed ${maxLength} characters`,
              },
            })}
            {...({
              className: "border border-gray-300 col-span-2 rounded-sm text-xs",
            } as any)}
          />
          <div className="flex justify-between items-center gap-2 text-xs mt-1">
            {errors?.notes && (
              <span className="text-red-500">
                {errors.notes.message as string}
              </span>
            )}
            <span className="text-gray-500">
              {notesValue.length} / {maxLength}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProducerCodeNotes;
